import { FC } from 'react'

import RFFFields from '../../react-final-form-fields'
import { IInfoCardRowFormProps } from './info-card-row-form-types'

const InfoCardRowForm: FC<IInfoCardRowFormProps> = props => {
  const { handleSubmit, submitting, formName, label, options } = props

  if (!options) {
    return null
  } else {
    const formattedOptions = options.map(option => ({
      label: option,
      value: option,
    }));

    return (
      <form onSubmit={handleSubmit} id={formName}>
        <RFFFields.Select
          name="selectedValue"
          label={label}
          options={formattedOptions}
          disabled={submitting}
        />
      </form>
    )
  }
}

export default InfoCardRowForm